import { render, staticRenderFns } from "./MerchantFeesCustom.vue?vue&type=template&id=0afe4dd6&scoped=true&"
import script from "./MerchantFeesCustom.vue?vue&type=script&lang=js&"
export * from "./MerchantFeesCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe4dd6",
  null
  
)

export default component.exports